export const HeightMap = {
  HEADER_HEIGHT: "38px",
  FOOTER_HEIGHT: "36px",
  TAB_HEIGHT: "41px"
};
